import React, { useState } from 'react';
import './App.css';
import { allSpeakVariants, SpeakVariant } from '../speak/meSpeak';
import { speakDefaults, speakPhonemes } from '../speak/speakPhonemes';
import { ChoiceList } from './widgets/ChoiceList';
import { RangeSlider } from './widgets/RangeSlider';
import { SaveLastAudio } from './widgets/SaveLastAudio';

/**
 * UI for editing the various speaking options:
 * pitch, speed, wordgap, variant
 */
export function EditSpeakOptions(props: { vertical?: boolean }) {
  const [pitch, setPitch] = useState(speakDefaults.pitch ?? 50);
  const [speed, setSpeed] = useState(speakDefaults.speed ?? 170);
  const [amplitude, setAmplitude] = useState(speakDefaults.amplitude ?? 100);
  const [wordgap, setWordgap] = useState(speakDefaults.wordgap ?? 0);
  const [variant, setVariant] = useState(speakDefaults.variant);

  function changePitch(pitch: number) {
    setPitch(pitch);
    speakDefaults.pitch = pitch;
  }

  function changeSpeed(speed: number) {
    setSpeed(speed);
    speakDefaults.speed = speed;
  }

  function changeAmplitude(amplitude: number) {
    setAmplitude(amplitude);
    speakDefaults.amplitude = amplitude;
  }

  function changeWordgap(wordgap: number) {
    setWordgap(wordgap);
    speakDefaults.wordgap = wordgap;
  }

  function changeVariant(variant: string) {
    setVariant(variant as SpeakVariant);
    speakDefaults.variant = variant as SpeakVariant;
  }

  /*
  const [immediate, setImmediate] = useState(speakDefaults.immediate);
  function changeImmediate(immediate: boolean) {
    setImmediate(immediate);
    speakDefaults.immediate = immediate;
    if (immediate) {
      speakSample('a');
      speakPhonemes('a');
    }
  }
  */
  function testAudio() {
    speakPhonemes("ˈtʰɛ190stɪ160ŋ ˈwɐ130n ˈtʰɯu̯190 ˈθɹi160");
  }

  if (props.vertical) {
    const width = 130;
    return (<span>
      <table><tbody>
        <tr>
          <td className="clean">voice</td>
          <td className="clean"><ChoiceList items={allSpeakVariants} selectedItem={variant} onSelect={changeVariant} /></td>
        </tr>
        <tr>
          <td className="clean">pitch</td>
          <td className="clean"><RangeSlider value={pitch} min={10} max={90} onChange={changePitch} width={width} /></td>
        </tr>
        <tr>
          <td className="clean">speed</td>
          <td className="clean"><RangeSlider value={speed} min={50} max={290} onChange={changeSpeed} width={width} /></td>
        </tr>
        <tr>
          <td className="clean">volume</td>
          <td className="clean"><RangeSlider value={amplitude} min={0} max={200} onChange={changeAmplitude} width={width} /></td>
        </tr>
        <tr>
          <td className="clean">wordgap</td>
          <td className="clean"><RangeSlider value={wordgap} min={0} max={20} onChange={changeWordgap} width={width} /></td>
        </tr>
      </tbody></table>
      <button onClick={testAudio}>test audio</button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <SaveLastAudio />
    </span>);
  }
  /*
  used to toggle immediate mode, but testAudio().speakSample() may be what actually fixes the problem
      <input type="checkbox" id={'immediate'} checked={immediate} onChange={(e) => changeImmediate(e.target.checked)} />
      <label htmlFor={'immediate'}>limited mode</label>
  */

  const controlSeparator = <>&nbsp;&nbsp;&nbsp;&nbsp;</>;
  return (<>
    variant:&nbsp;<ChoiceList items={allSpeakVariants} selectedItem={variant} onSelect={changeVariant} />
    {controlSeparator}
    pitch:&nbsp;<RangeSlider value={pitch} min={10} max={90} onChange={changePitch} />
    {controlSeparator}
    speed:&nbsp;<RangeSlider value={speed} min={50} max={290} onChange={changeSpeed} />
    {controlSeparator}
    wordgap:&nbsp;<RangeSlider value={wordgap} min={0} max={20} onChange={changeWordgap} />
    {controlSeparator}
    <SaveLastAudio />
  </>);
}
